import { render, staticRenderFns } from "./PersonWithDisability.vue?vue&type=template&id=a4d0e766"
import script from "./PersonWithDisability.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonWithDisability.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports